export const TEST = 'test';
export const LIVE = 'live';
export const ADYEN_API_CRED_CLIENTKEY_NPR = 'test_F4F4G7A5LBA2BPY53KBKXCR7WEDP3WZH';
export const AUTHORISED = 'Authorised';
export const CANCELLED = 'Cancelled';
export const REFUSED = 'Refused'
export const RECEIVED = 'Received'
export const THREEDS2_FINGERPRINT = '3DS2Fingerprint';
export const THREEDS2_CHALLENGE = '3DS2Challenge';
export const CARD = 'card';
export const ADYEN_COMPONENT_SESSION_KEY = '__adyen_component_session__';
export const PAYMENT_METHOD_CREDIT_CARD_ADYEN = 'credit_card_adyen';
export const PAYMENT_METHOD_GOOGLE_PAY_ADYEN = 'google_pay_adyen';
export const PAYMENT_METHOD_KLARNA_PAY_NOW_ADYEN = 'klarna_pay_now_adyen';
export const PAYMENT_METHOD_IDEAL_ADYEN = 'ideal_adyen';
export const PAYMENT_METHOD_KLARNA_PAY_NOW_CONFIGURATION = {'paymentMethods':[{'name': 'Pay now with Klarna.','type': 'klarna_paynow'}]};
export const LOCALE_UPDATED_SALE_LINK = ['en-US', 'en-CA'];
export const SESSION_EXPIERY_TIME = 1800000; //30min in milliseconds
export const TRANSACTION_MAX_COUNT = 1;
export const KLARNA_PAY_NOW = 'klarna_paynow';
export const KLARNA_PAY_NOW_CONFIGURATION = { useKlarnaWidget: true, type: 'klarna_paynow' };
export const BRAINTREE_FIELD_NAMES = ['number', 'cvv', 'expirationDate', 'cardholderName'];
export const FR: string = 'FR';